import { Close } from '@ifood/pomodoro-icons';
import * as React from 'react';

import { NOTIFICATION_VARIANTS } from '../../types';
import { CloseButton, Container, Content, Markup } from './styles';

type PropTypes = {
  variant: NOTIFICATION_VARIANTS;
  onCloseClick?: () => void;
};

export const NotificationContent: React.FC<PropTypes> = ({ children, variant, onCloseClick }) => (
  <Container variant={variant}>
    <Content>
      <Markup>{children}</Markup>
      <CloseButton onClick={onCloseClick}>
        <Close />
      </CloseButton>
    </Content>
  </Container>
);
